import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Infinity, AlertCircle } from 'lucide-react';
const stats = [{
  Icon: Clock,
  value: '52',
  unit: 'domingos',
  label: 'al año planificando',
  desc: 'Noches y fines de semana enteros armando clases a último momento.'
}, {
  Icon: Infinity,
  value: '∞',
  unit: 'horas',
  label: 'buscando secuencias',
  desc: 'YouTube, libros, Instagram... y nunca encontrás lo que necesitás.'
}, {
  Icon: AlertCircle,
  value: '1',
  unit: 'problema',
  label: 'constante: empezar desde cero',
  desc: 'Llegar a la clase sin saber exactamente qué hacer y perder la fluidez.'
}];
// ... existing code ...
export function HiddenCost() {
  return <section className="py-24 lg:py-32 bg-transparent" data-id="element-119">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-121">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-50 text-accent-700 font-medium text-xs uppercase tracking-widest mb-6 border border-accent-100/50" data-id="element-122">
            Hablemos en serio
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-900 mb-6 leading-tight tracking-tight" data-id="element-123">
            El verdadero costo de{' '}
            <span className="text-brand-600 italic" data-id="element-124">improvisar tus clases</span>
          </h2>
          <p className="text-lg text-ink-600 font-light leading-relaxed" data-id="element-125">
            No es solamente tiempo. Es sentir que podrías dar mucho más si
            tuvieras una planificación clara.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-126">
          {stats.map((s, i) => {
          const Icon = s.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="group bg-accent-50/50 rounded-[2rem] p-8 lg:p-10 hover:bg-accent-50 transition-colors" data-id="element-127">
                <div className="w-14 h-14 rounded-full bg-white text-brand-700 flex items-center justify-center mb-8 shadow-sm group-hover:scale-105 transition-transform" data-id="element-128">
                  <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-129" />
                </div>
                <div className="flex items-baseline gap-2 mb-3" data-id="element-130">
                  <span className="text-5xl md:text-6xl font-serif font-medium text-brand-800 leading-none" data-id="element-131">
                    {s.value}
                  </span>
                  <span className="text-sm font-medium text-ink-500 uppercase tracking-widest" data-id="element-132">
                    {s.unit}
                  </span>
                </div>
                <div className="text-lg font-medium text-ink-900 mb-4" data-id="element-133">
                  {s.label}
                </div>
                <p className="text-ink-600 leading-relaxed text-sm font-light" data-id="element-134">
                  {s.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}